import { render, staticRenderFns } from "./SfModal.vue?vue&type=template&id=1b3c7fc4&scoped=true&"
import script from "./SfModal.vue?vue&type=script&lang=js&"
export * from "./SfModal.vue?vue&type=script&lang=js&"
import style0 from "./SfModal.vue?vue&type=style&index=0&id=1b3c7fc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3c7fc4",
  null
  
)

export default component.exports